import { ChangeDetectionStrategy, Component, computed, effect, inject, input } from '@angular/core';
import { KeywordsInlineViewComponent } from './views/keywords-inline-view/keywords-inline-view.component';
import { ProductComponentBase } from '../../../ProductComponentBase';
import { ProductComponentStore, ProductCrossReferencesComponentStore2 } from 'products-data';

@Component({
  selector: 'ideal-xrefs-inline',
  imports: [KeywordsInlineViewComponent],
  templateUrl: './keywords-inline.component.html',
  styleUrl: './keywords-inline.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  providers: [ProductComponentStore, ProductCrossReferencesComponentStore2],
})
export class XrefInlineComponent extends ProductComponentBase {
  private readonly _store = inject(ProductCrossReferencesComponentStore2);
  public readonly match = input<string>('');
  public readonly matchType = input<'startsWith' | 'endsWith' | 'contains'>('startsWith');
  public readonly caseSensitiveMatch = input<boolean>(false);
  protected readonly keywords = computed(() => this._store.crossReferences()?.map((xref) => xref.crossReference));
  protected readonly keywordsLoading = computed(() => this._store.crossReferences.loading());

  constructor() {
    super();
    effect(() => {
      this._store.setSelectedProductId(this.productId());
    });
  }
}
